module.exports = __webpack_public_path__ + "static/media/product.21a57700.svg";